import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormLabel, Stack, TextField, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid2";
import { ChangeEvent, useState } from "react";
import { FormContainer } from "react-hook-form-mui";
import ExportMonitoringReportViewModel from "../../../ViewModels/TravelPlan/ExportMonitoringReportViewModel";
interface IProps {
    dialogOpen: boolean;
    handleClose: () => void;
    exportMonitoringReport: (exportVm: ExportMonitoringReportViewModel) => void;
    isExporting: boolean;
}
export default function MonitoringReportExportDialog({ dialogOpen, handleClose, exportMonitoringReport, isExporting }: IProps) {
    const [exportFilters, setExportFilters] = useState(new ExportMonitoringReportViewModel());


    const handleText = (e: ChangeEvent<HTMLInputElement>) => {
        setExportFilters(f => ({
            ...f,
            [e.target.name]: (e.target as HTMLInputElement).value
        }))
    }
    const handleCheck = (e: ChangeEvent<HTMLInputElement>) =>
        setExportFilters(f => ({ ...f, [e.target.name]: e.target.checked }));



    return (
        <Dialog open={dialogOpen} onClose={isExporting ? undefined : handleClose} maxWidth="sm">
            <DialogTitle><Typography variant={"h6"}>Monitoring Report Export</Typography></DialogTitle>
            <DialogContent>
                <FormContainer>
                    <Grid container size={12}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="addUserComments"
                                        checked={exportFilters.addUserComments}
                                        onChange={handleCheck}
                                        size="small"
                                    />
                                }
                                label="Add User Comments"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="displayDirectlyToScreen"
                                        checked={exportFilters.displayDirectlyToScreen}
                                        onChange={handleCheck}
                                        size="small"
                                    />
                                }
                                label="Display PDF directly to screen"
                            />
                            <Stack spacing={1}>
                                <FormLabel>File Name</FormLabel>
                                <TextField
                                    name="fileName"
                                    value={exportFilters.fileName}
                                    onChange={handleText}
                                    size="small"
                                />
                            </Stack>
                            {exportFilters.addUserComments &&

                                <Stack spacing={1}>
                                    <FormLabel>Comments</FormLabel>
                                    <TextField
                                        name="userComments"
                                        value={exportFilters.userComments}
                                        onChange={handleText}
                                        size="small"
                                    />
                                </Stack>
                            }
                        </FormGroup>

                    </Grid>
                </FormContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={isExporting}>Cancel</Button>
                <Button onClick={() => exportMonitoringReport(exportFilters)} disabled={isExporting}>
                    {isExporting ? (
                        <>
                            <CircularProgress size={18} sx={{ mr: 1 }} />
                            Generating PDF...
                        </>
                    ) : (
                        "Submit"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
